<template>
  <div id="configuraciones" class="tab-detalle has-text-left">
    <h3 class="has-text-weight-bold is-red is-uppercase">{{ this.$i18n.t('general.ConfStandardIQuote') }}</h3>
    <div class="botones-scroll is-hidden-mobile is-hidden-tablet-only pb-0" v-show="configuraciones.length>2">
      <b-button
        class="has-text-weight-bold is-pulled-left pt-0"
        @click="scroll_left"
        type="is-istobal-gris-claro">
        <b-icon
            pack="fas"
            icon="arrow-left"
            size="is-small">
        </b-icon>
      </b-button>
      <b-button
        class="has-text-weight-bold is-pulled-right pt-0"
        @click="scroll_right"
        type="is-istobal-gris-claro">
        <b-icon
            pack="fas"
            icon="arrow-right"
            size="is-small">
        </b-icon>
      </b-button>
    </div>
    <div class="scrolling-wrapper scroll-horizontal">
      <div v-for="config in configuraciones" :key="'confest_'+config.codigo" :class="{opcion: true, selected: configSel && config.codigo === configSel.codigo}">
        <b-button @click="selectConfig(config)">
          <p class="imagen has-text-centered">
            <img :src="backendurl+config.foto" :alt="config.titulo[lang.replace('_','-').toLowerCase()]" />
          </p>
          <p class="texto">{{ config.codigo}}</p>
        </b-button>
      </div>
    </div>
    <p class="is-size-6 mt-2">{{ this.$i18n.t('general.ClickSelectColor') }}</p>


    <div class="colores has-text-left" v-if="configSel">
<!--      <b-button type="is-RAL9016" @click="isColoresModalActive = true">1</b-button> <p @click="isColoresModalActive = true">RAL9016</p>
      <b-button type="is-RAL5004" @click="isColoresModalActive = true">2</b-button> <p @click="isColoresModalActive = true">RAL5004</p>-->
      <span v-for="col in configSel.numerocolores" :key="'colconfig_'+col">
        <template v-if="col==1 || skuactivo!='Puente_Istobal_MWASH3PRO_Alto_Blanco'">
        <b-button :type="'is-'+selected_color[col]" @click="activateModalColor(col)" v-show="skuactivo!='Puente_Istobal_MWASH3PRO_Alto_Blanco'">{{ col }}</b-button><p @click="isColoresModalActive = true" class="nombre_color" v-show="skuactivo!='Puente_Istobal_MWASH3PRO_Alto_Blanco'">{{ selected_color[col] }}</p>
        </template>
        <template v-else>
        <b-button :type="'is-'+selected_color[col]" @click="activateModalColor(col)">{{ skuactivo!='Puente_Istobal_MWASH3PRO_Alto_Blanco'? col : (col -1) }}</b-button><p @click="isColoresViniloModalActive = true" class="nombre_color">{{ selected_color[col] }}/{{ coloresRALToCodigo(selected_color[col]) }}</p>
        </template>
      </span>

    </div>
    <b-modal
        v-model="isColoresModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.ColorSelector')"
        aria-modal
        custom-class="selector-colores configuraciones">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris">{{ this.$i18n.t('general.SelectColor') }}</h4>
            <!--<a class="close has-text-right is-size-7">
              <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
            </a>-->
            <div class="colores has-text-centered">
              <b-button  v-for="(color) in colores" :key="'color_'+color" :type="'is-'+color" @click="selColor(color)" :focused="color === selected_color[choosingColor]"></b-button>
            </div>
            <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isColoresModalActive = false">{{ this.$i18n.t('general.Cancel') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="isColoresViniloModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.ColorSelector')"
        aria-modal
        custom-class="selector-colores configuraciones">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris">{{ this.$i18n.t('general.SelectColor') }}</h4>
            <!--<a class="close has-text-right is-size-7">
              <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
            </a>-->
            <div class="colores has-text-centered">
              <b-button  v-for="(color) in coloresVinilo" :key="'color_'+color" :type="'is-'+color" @click="selColor(color)" :focused="color === selected_color[choosingColor]">{{ color }}</b-button>
            </div>
            <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isColoresViniloModalActive = false">{{ this.$i18n.t('general.Cancel') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "configuraciones",
  props: ['colores','coloresVinilo','configuraciones','lang','backendurl','skuactivo'],
  data (){
    return {
      isColoresModalActive: false,
      isColoresViniloModalActive: false,
      selected_opcion: null,
      selected_color: [],
      lopciones : null,
      emitir: false,
      configSel: null,
      choosingColor: 0,
      debugMode: process.env.VUE_APP_DEBUGMODE == 1 ? true : false
    }
  },
  mounted() {
    //TODO: Quitar este hardcodeado porque ya se pasa como prop al componente
    if (this.debugMode === true ) console.log('Cargado componente Configuracion !!! ' + this.configSel)
    if (this.$store.getters.getConfiguracionStandardActiva.codigo !== null){
      this.configSel = this.configuraciones.find(el => {return el.codigo == this.$store.getters.getConfiguracionStandardActiva.codigo})
      if (this.debugMode === true && !this.configSel) console.log('No he encontrado la configuración a mantener activa !!!')
      if (!this.configSel){
        this.configSel = this.configuraciones[0]
        this.$store.commit('setConfiguracionStandardActiva',this.configuraciones[0])
      }
      if (this.debugMode === true) console.log('Tengo configuracion activa.')
    }else{
      this.configSel = this.configuraciones[0]
      this.$store.commit('setConfiguracionStandardActiva',this.configuraciones[0])
    }

    this.initColors()


  },
  computed: {
    configuracionActiva(){
      return this.configSel ? this.configSel.codigo : null
    },

    configStandardActiva(){
      return this.$store.getters.getConfiguracionStandardActiva.codigo
    },

  },

  methods: {

    selectConfig(config){
      if (this.configSel && this.configSel.codigo !== config.codigo){

        this.configSel = config
        this.$store.commit('setConfiguracionStandardActiva',config)
        this.$store.dispatch('aplicarConfiguracion',config)
        this.trackEventGA("Configurador",this.skuactivo+"-cambio-iquote",config.codigo);
        if (this.selected_color.length>0){

          this.configSel.grupos.forEach(grupo => {
            let color = this.selected_color[grupo.codigo]

            if (typeof color !== 'undefined') {

              this.selColor(color, grupo.codigo)

            }else{
                let color = this.$store.getters.getConfigBackend.colores.find(el => el.codigo == grupo.color).ral
                this.selColor(color,grupo.codigo)
            }



          })

        }else{
          this.initColors()

        }
      }else{
        if (this.debugMode === true) console.log('No cambia la configuracion !!!')
      }



    },
    initColors(){
      //console.log('Inicializamos colores !!!!')
      if (this.debugMode === true) console.log('Número colores configuraciones: '+this.configSel.numerocolores)
      let i=0;
      for (i=1;i<=this.configSel.numerocolores;i++){
        let grupo = this.configSel.grupos.find(grupo => grupo.codigo == i)
        let indicecolores = "colores"
        if (this.skuactivo=='Puente_Istobal_MWASH3PRO_Alto_Blanco' && i==2){
          indicecolores += "vinilo"
        }
        if (process.env.VUE_APP_ES_PUBLIC == 1){
            indicecolores += "_publica"
        }
        let color = this.$store.getters.getConfigBackend[indicecolores].find(el => el.codigo == grupo.color).ral
        if (this.skuactivo=='Puente_Istobal_MWASH3PRO_Alto_Blanco' && i==1){//20230426: Si vengo de otra máquina y voy a la MWAS3-PRO fuerzo el color del carenado
          color = "RAL9016";
        }else if (i==2){//20230417: Sólo aplico el color que estaba activo si está entre los disponibles. Esto puede suceder a patir de introducir los colores de vinilos en el grupo dos de las configuraciones.
          if (this.debugMode === true) console.log('Indice colores: ' + indicecolores + ' => Color obtenido del backend: '+ this.$store.getters.getConfigBackend[indicecolores].find(el => el.codigo == grupo.color).ral +' => Color activo: '+ this.$store.getters['getColorConfig'+i] +'')

          if (this.$store.getters['getColorConfig'+i]!==null){
            if (this.debugMode === true) console.log('Colores disponibles: ' + JSON.stringify(this.$store.getters.getConfigBackend[indicecolores]) + '')
            if (typeof this.$store.getters.getConfigBackend[indicecolores].find(el => el.ral == this.$store.getters['getColorConfig'+i]) !== 'undefined') {
              color = this.$store.getters['getColorConfig'+i];
            }
          }
        }else if (this.$store.getters['getColorConfig'+i]!==null){
          color = this.$store.getters['getColorConfig'+i];
        }

        this.selected_color[i]=color
        this.$store.commit('setColorConfig'+i,color)
        this.selColor(color,grupo.codigo)

      }
    },

    selColor(color,ngrupo) {
      if (ngrupo == null){
        ngrupo = this.choosingColor
      }else{
        this.choosingColor = ngrupo
      }

      this.selected_color[ngrupo] = color
      this.$store.commit('setColorConfig'+ngrupo,color)
      this.trackEventGA("Configurador",this.skuactivo+"-cambiocolor-iquote",ngrupo+"-"+color);
      let grupo = false;
      if (this.skuactivo=='Puente_Istobal_MWASH3PRO_Alto_Blanco'){
        grupo = this.configSel.grupos.find(grupo => grupo.codigo == 2)
      }else{
        grupo = this.configSel.grupos.find(grupo => grupo.codigo == this.choosingColor)
      }
      let modelo = this.$store.getters.getModeloActivo
      //console.log("Modelo ...." + modelo)
      //this.$store.commit('setLoading', true)
      grupo.partescolorear.forEach(parte => {
        //console.log('Coloreamos ...' + parte)
        if (parte == 'carenado'){
          parte = 'modelos'
        }
        if (this.skuactivo!='Puente_Istobal_MWASH3PRO_Alto_Blanco' && parte=="vinilo"){
          if (this.debugMode === true) console.log('Fuerzo cambio vinilo > estructura. Este puente no tiene vinilos.')
          parte = 'estructura'
        }else if (this.skuactivo=='Puente_Istobal_MWASH3PRO_Alto_Blanco' && parte=="estructura"){
          if (this.debugMode === true) console.log('Fuerzo cambio estructura > vinilo. El color de la estructura está forzado y no se elige.')
          parte = 'vinilo'
        }
        let opcion = this.$store.getters.getPartesSeleccionadas[parte] || modelo

          //this.$store.commit('addVariacion',{'parte': parte, cambio: 'color',valor:  color, opcion: modelo})
        this.$store.commit('setSolicitar',false)
        if (this.debugMode === true) console.log('Registrar cambio: '+ parte +' => '+ color +' => '+opcion)
        this.$emit('registrar-cambio',{'parte': parte, cambio: 'color',valor:  color, opcion: opcion},false)

        if (this.skuactivo=='Puente_Istobal_MWASH3PRO_Alto_Blanco'){
          if (parte=='vinilo'){
            let tejas = [{"orden":"1","nombre":{"es":"Liso","en":"Flat"},"frontal-superior":"Puente_Istobal_MWASH3PRO_Alto_Blanco-frontal-rodillo-liso-1-superior.png","trasera-superior":"Puente_Istobal_MWASH3PRO_Alto_Blanco-trasera-rodillo-liso-1-superior.png","frontal-lateral":"Puente_Istobal_MWASH3PRO_Alto_Blanco-frontal-rodillo-liso-1-lateral.png","trasera-lateral":"Puente_Istobal_MWASH3PRO_Alto_Blanco-trasera-rodillo-liso-1-lateral.png","colorear":true,"default":false,"color":color}]
            if (this.debugMode === true) console.log('Cambio automático color cepillo')
            if (this.debugMode === true) console.log(JSON.stringify(tejas))
            this.$emit('registrar-cambio',{'parte': "cepillo", cambio: 'tipo',valor: 'Liso', 'tejas': tejas, 'solicitar':false},false);
          }
        }


      })

      if (this.debugMode === true) console.log('Pido frontal (Configuraciones. Select color)')
      this.$store.dispatch('solicitarImagenes','frontal')
      if (this.debugMode === true) console.log('Pido trasera (Configuraciones. Select color)')
      this.$store.dispatch('solicitarImagenes','trasera')
      //this.$store.dispatch('solicitaImgFrontAndBack')

      //this.$store.commit('setLoading', false)
      this.choosingColor = 0



      this.isColoresModalActive = false
      this.isColoresViniloModalActive = false
    },
    activateModalColor(col){
      this.choosingColor=col
      if (col==2 && this.skuactivo=='Puente_Istobal_MWASH3PRO_Alto_Blanco'){
        this.isColoresViniloModalActive = true
      }else{
        this.isColoresModalActive = true
      }

    },
    scroll_left() {
      let content = document.querySelector(".scroll-horizontal");
      content.scrollLeft -= 50;
    },
    scroll_right() {
      let content = document.querySelector(".scroll-horizontal");
      content.scrollLeft += 50;
    },
    trackEventGA(categoria,accion,label){
      this.$gtm.trackEvent({
        event: 'configurador-evento', // Event type [default = 'interaction'] (Optional)
        category: categoria,
        action: accion,
        label: label,
        noninteraction: false
      });
    },
    coloresRALToCodigo(color){
      if (this.debugMode === true ) console.log('Convirtiendo color ' + color)
      //De momento solo vinilos/cepillos
      let codigosColor = [{"Codigo":"AM5","RAL":"RAL1016"},{"Codigo":"AZ2","RAL":"RAL5002"},{"Codigo":"AZ3","RAL":"RAL5003"},{"Codigo":"AZJ","RAL":"RAL5013"},{"Codigo":"AZL","RAL":"RAL5015"},{"Codigo":"GR1","RAL":"RAL7037"},{"Codigo":"GR7","RAL":"RAL7016"},{"Codigo":"NA1","RAL":"RAL2008"},{"Codigo":"NE1","RAL":"RAL9011"},{"Codigo":"RO6","RAL":"RAL3018"},{"Codigo":"RO6","RAL":"RAL3018_USA"},{"Codigo":"VE1","RAL":"RAL6028"},{"Codigo":"VE2","RAL":"RAL6018"},{"Codigo":"VE3","RAL":"RAL6032"},{"Codigo":"VE4","RAL":"PANT382"},{"Codigo":"VI2","RAL":"RAL4005"}]
      if (color!=='' && (color.startsWith('RAL') || color.startsWith('PANT'))){
        if (this.debugMode === true ) console.log('RAL detectado')
        let valor = codigosColor.find(el => el.RAL == color)
        if (valor){
          if (this.debugMode === true ) console.log('Encontrado código para el RAL =>' + valor.Codigo)
          return valor.Codigo
        }else{
          if (this.debugMode === true ) console.log('NO he encontrado código para el RAL')
          return color
        }
      }else{
        return color
      }

    }
  },
  watch: {
    configuracionActiva: function (newV){
      if (newV){
        //console.log('Nueva configuracion activa !')


      }
    },
    /*
    configStandardActiva : function (newV){
      if (newV){
        console.log('entra aquiiiiii')
        //if (this.$store.getters.getConfiguracionStandardActiva.codigo!==null){
          //this.$store.commit('setConfiguracionStandardActiva',this.$store.getters.getConfiguracionStandardActiva.codigo)
          this.$store.commit('setColorConfig1',this.$store.getters.getConfiguracionStandardActiva.colorConfig1)
          this.$store.commit('setColorConfig2',this.$store.getters.getConfiguracionStandardActiva.colorConfig2)
        //}else{
          //this.$store.commit('setConfiguracionStandardActiva',this.configuraciones[0])
        //}
      }
    }*/


  }
}
</script>

<style scoped>

</style>
